<template>
  <div>
    <!-- Sidebar -->
    <div
        :class="[
        'fixed top-0 left-0 h-full flex flex-col justify-between shadow-lg transition-transform duration-300 ease-in-out z-[1000]',
        isSidebarOpen ? 'translate-x-0' : '-translate-x-full',
        'bg-sidebar-bg dark:bg-dark-sidebar-bg text-sidebar-text dark:text-dark-sidebar-text'
      ]"
        class="w-full sm:w-3/4 md:w-2/5 lg:w-64 h-full sidebar-content overflow-y-auto"
    >
      <!-- Sekcja z datą i godziną -->
      <div class="sidebar-header sticky top-0 bg-teal-700 p-4 sm:p-5 rounded-br-3xl text-white">
        <div class="mb-3 sm:mb-4">
          <p class="text-sm sm:text-base font-bold">Data i godzina:</p>
          <p class="text-xs sm:text-sm font-medium mt-1">{{ currentDateTime }}</p>
        </div>
      </div>

      <!-- Menu sidebar -->
      <div class="sidebar-navigation overflow-y-auto">
      <ul class="space-y-3 sm:space-y-4 mt-6 sm:mt-8 px-4 sm:px-5">
        <li v-for="link in navigationLinks" :key="link.text">
          <router-link
            :is="link.action ? 'a' : 'router-link'"
            :to="link.url"
            :href="link.action ? link.url : null"
            @click.prevent="link.action ? link.action() : null"
            @contextmenu.prevent="openInNewTab(link)"
            :class="[
              'flex items-center p-2 sm:p-3 rounded-md transition',
              link.url && isActiveLink(link.url) ? 'bg-teal-700 text-white' : 'hover:bg-teal-700 hover:text-white'
            ]"
          >
            <span class="mr-2 sm:mr-3">
              <HomeIcon v-if="link.text === 'Dashboard'" class="h-5 w-5 sm:h-6 sm:w-6 text-inherit" />
              <DocumentIcon v-else-if="link.text === 'Zlecenia'" class="h-5 w-5 sm:h-6 sm:w-6 text-inherit" />
              <TruckIcon v-else-if="link.text === 'Kierowcy'" class="h-5 w-5 sm:h-6 sm:w-6 text-inherit" />
              <UsersIcon v-else-if="link.text === 'Pasażerowie'" class="h-5 w-5 sm:h-6 sm:w-6 text-inherit" />
              <DocumentChartBarIcon v-else-if="link.text === 'Archiwum Zleceń'" class="h-5 w-5 sm:h-6 sm:w-6 text-inherit" />
              <UserGroupIcon v-else-if="link.text === 'Dyspozytorzy'" class="h-5 w-5 sm:h-6 sm:w-6 text-inherit" />
              <MapIcon v-else-if="link.text === 'Stacje Kolejowe'" class="h-5 w-5 sm:h-6 sm:w-6 text-inherit" />
              <BuildingOffice2Icon v-else-if="link.text === 'Hotele'" class="h-5 w-5 sm:h-6 sm:w-6 text-inherit" />
              <BuildingOfficeIcon v-else-if="link.text === 'Firmy'" class="h-5 w-5 sm:h-6 sm:w-6 text-inherit" />
              <CreditCardIcon v-else-if="link.text === 'Rozliczenia'" class="h-5 w-5 sm:h-6 sm:w-6 text-inherit" />
              <CreditCardIcon v-else-if="link.text === 'Historia'" class="h-5 w-5 sm:h-6 sm:w-6 text-inherit" />
              <Cog6ToothIcon v-else-if="link.text === 'Ustawienia'" class="h-5 w-5 sm:h-6 sm:w-6 text-inherit" />
              <ChatBubbleBottomCenterIcon v-else-if="link.text === 'Wiadomości'" class="h-5 w-5 sm:h-6 sm:w-6 text-inherit" />
              <ExclamationTriangleIcon v-else-if="link.text === 'Zgłoś awarię'" class="h-5 w-5 sm:h-6 sm:w-6 text-inherit" />
            </span>
            <span class="font-medium text-sm sm:text-base text-inherit">{{ link.text }}</span>
          </router-link>
        </li>
      </ul>
    </div>
      <!-- Dolna część z przyciskami -->
      <div class="sidebar-footer space-y-3">
        <p class="text-center text-xs sm:text-sm text-gray-500 dark:text-gray-400">v1.0.3</p>

        <!-- Przycisk zmiany motywu -->
        <button
            @click="toggleTheme"
            class="w-full p-2 sm:p-3 bg-button-bg text-button-text rounded-md transition hover:bg-button-hover dark:bg-dark-button-bg dark:text-dark-text dark:hover:bg-dark-button-hover flex items-center justify-center"
        >
    <span v-if="isDarkMode">
      <MoonIcon class="h-5 w-5 sm:h-6 sm:w-6" />
    </span>
          <span v-else>
      <SunIcon class="h-5 w-5 sm:h-6 sm:w-6" />
    </span>
        </button>

        <!-- Przycisk wylogowania -->
        <a
            href="#"
            @click.prevent="logout"
            class="flex items-center justify-center p-2 sm:p-3 bg-teal-700 text-white rounded-md transition hover:bg-red-500"
        >
    <span class="mr-2">
      <ArrowRightOnRectangleIcon class="h-5 w-5 sm:h-6 sm:w-6" />
    </span>
          <span class="text-sm sm:text-base">Wyloguj</span>
        </a>
      </div>
    </div>

    <!-- Toggle sidebar button -->
    <button
        v-show="isButtonVisible"
        @click="toggleSidebar"
        :class="[
        'fixed top-0 transition-all duration-300 ease-in-out transform z-[1000]',
        isSidebarOpen ? 'left-[74vw] sm:left-[60vw] md:left-[25vw] lg:left-[8rem]' : 'left-[-40px]',
        'bg-teal-700 p-5 mx-6 rounded-r-full text-white'
      ]"
    >
      <ChevronLeftIcon v-if="isSidebarOpen" class="h-8 w-8" />
      <ChevronRightIcon v-else class="h-8 w-8" />
    </button>

    <!-- Overlay that closes sidebar on click outside -->
    <div
        v-if="isSidebarOpen"
        class="fixed inset-0 bg-black bg-opacity-50 z-[500] transition-opacity duration-300"
        @click="closeSidebar"
    ></div>

    <!-- Główna zawartość strony -->
    <div :class="[
      'transition-all duration-300 ease-in-out',
      isSidebarOpen ? 'ml-[50vw] sm:ml-[40vw] md:ml-[30vw] lg:ml-64' : ''
    ]">
      <slot></slot>
    </div>
  </div>
</template>


<script>
import {useAuthStore} from '@/stores/authStore';
import {RoleMap} from './utils/roleMap';
import {
  HomeIcon,
  DocumentIcon,
  TruckIcon,
  BuildingOfficeIcon,
  UsersIcon,
  Cog6ToothIcon,
  MoonIcon,
  SunIcon,
  ArrowRightOnRectangleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DocumentChartBarIcon,
  MapIcon,
  UserGroupIcon,
  CreditCardIcon,
  ChatBubbleBottomCenterIcon,
  ExclamationTriangleIcon,
  BuildingOffice2Icon
} from '@heroicons/vue/24/solid';
import notificationService from '@/services/notificationService';

export default {
  components: {
    HomeIcon,
    DocumentIcon,
    TruckIcon,
    BuildingOfficeIcon,
    UsersIcon,
    Cog6ToothIcon,
    MoonIcon,
    SunIcon,
    ArrowRightOnRectangleIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    DocumentChartBarIcon,
    MapIcon,
    UserGroupIcon,
    CreditCardIcon,
    ChatBubbleBottomCenterIcon,
    ExclamationTriangleIcon,
    BuildingOffice2Icon
  },
  data() {
    return {
      isSidebarOpen: false,
      isDarkMode: localStorage.getItem('theme') === 'dark',
      navigationLinks: [],
      user: useAuthStore().user,
      currentDateTime: '',
      isSettingsModalVisible: false, // Nowy stan modala
      isDesktop: window.innerWidth >= 1024, // Przyjmujemy, że desktop to >= 1024px

      isButtonVisible: true, // Widoczność przycisku
      lastScrollY: 0, // Ostatnia pozycja przewinięcia
    };
  },
  methods: {
      openInNewTab(link) {
      if (link.action) {
        // Dla linków z akcjami - nie otwieraj w nowej karcie
        return;
      }
      
      if (link.url) {
        const fullUrl = window.location.origin + link.url;
        window.open(fullUrl, '_blank');
      }
    },
    handleLinkClick(event, link) {
      if (event.ctrlKey || event.metaKey || event.button === 1) {
        // Ctrl+click, Cmd+click lub middle click - otwórz w nowej karcie
        event.preventDefault();
        this.openInNewTab(link);
        return;
      }
      
      if (link.action) {
        event.preventDefault();
        link.action();
      }
      // Dla router-link standardowe zachowanie
    },
    handleScroll() {
      const currentScrollY = window.scrollY;

      // Ukryj przycisk, jeśli przewijanie w dół, pokaż przy przewijaniu w górę
      this.isButtonVisible = currentScrollY <= this.lastScrollY;

      // Debug: Wyświetl w konsoli informacje o stanie
      // console.log("Scroll Y:", currentScrollY, "Last Scroll Y:", this.lastScrollY, "isButtonVisible:", this.isButtonVisible);

      // Aktualizacja ostatniej pozycji przewinięcia
      this.lastScrollY = currentScrollY;
    },
    getRoleInPolish(role) {
      return RoleMap[role] || 'Nieznana rola';
    },
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;

      // Blokuj lub odblokuj przewijanie strony
      if (this.isSidebarOpen) {
        document.body.classList.add('overflow-hidden');
      } else {
        document.body.classList.remove('overflow-hidden');
      }
    },
    closeSidebar() {
      this.isSidebarOpen = false;
      document.body.classList.remove('overflow-hidden');
    },
    toggleTheme() {
      this.isDarkMode = !this.isDarkMode;
      const newTheme = this.isDarkMode ? 'dark' : 'light';
      document.documentElement.classList.toggle('dark', this.isDarkMode);

      localStorage.setItem('theme', newTheme);
      console.log('Zapisuję motyw w localStorage:', newTheme);

      // Odświeżenie strony po zmianie motywu
      location.reload();
    },
    async login() {
      try {
        // Twoja logika logowania
        const savedTheme = localStorage.getItem('theme') || 'light'; // Pobierz ostatnio zapisany motyw
        const isDarkMode = savedTheme === 'dark';

        // Ustaw motyw globalnie
        document.documentElement.classList.toggle('dark', isDarkMode);
      } catch (error) {
        console.error('Błąd podczas logowania:', error);
      }
    },
    async logout() {
      try {
        const savedTheme = localStorage.getItem('theme');
        console.log('Zachowuję motyw przed wylogowaniem:', savedTheme);
        const authStore = useAuthStore();
        await authStore.logout(true);
        localStorage.setItem('theme', savedTheme);
        console.log('Przywracam motyw po wylogowaniu:', savedTheme);
        // this.setThemeFromLocalStorage();
        this.$router.push('/login');
      } catch (error) {
        console.error('Błąd podczas wylogowania:', error);
      }
    },
    async fetchWarnings() {
      await notificationService.reportBreakdown(this.user.uid);
      // this.showMessage("Awaria została zgłoszona pomyślnie.", "success");
      const authStore = useAuthStore();
      await authStore.fetchDriverData(this.user.uid);
    },

    setupNavigationLinks() {
      const authStore = useAuthStore();
      if (!authStore.isAuthenticated) {
        this.navigationLinks = [
          {text: 'Register', url: '/register'},
          {text: 'Login', url: '/login'}
        ];
      } else if (authStore.user.role === 'ROLE_YOUNG_DISPATCHER') {
        this.navigationLinks = [
          {text: 'Dashboard', url: '/dispatcher/dashboard'},
          {text: 'Zlecenia', url: '/dispatcher/orders'},
          {text: 'Rozliczenia', url: '/dispatcher/payoff'},
          {text: 'Kierowcy', url: '/dispatcher/drivers'},
          {text: 'Pasażerowie', url: '/dispatcher/passengers'},
          {text: 'Archiwum Zleceń', url: '/dispatcher/orderArchive'},
          {text: 'Firmy', url: '/dispatcher/companies'},
          {text: 'Stacje Kolejowe', url: '/dispatcher/stations'},
          {text: 'Hotele', url: '/dispatcher/hotels'},
          {text: 'Ustawienia', url: '/dispatcher/settings'}
        ];
      }
      else if (authStore.user.role === 'ROLE_ADULT_DISPATCHER')
      {
        this.navigationLinks = [
          {text: 'Dashboard', url: '/dispatcher/dashboard'},
          {text: 'Zlecenia', url: '/dispatcher/orders'},
          {text: 'Rozliczenia', url: '/dispatcher/payoff'},
          {text: 'Kierowcy', url: '/dispatcher/drivers'},
          {text: 'Pasażerowie', url: '/dispatcher/passengers'},
          {text: 'Archiwum Zleceń', url: '/dispatcher/orderArchive'},
          {text: 'Firmy', url: '/dispatcher/companies'},
          {text: 'Dyspozytorzy', url: '/dispatcher/dispatchers'},
          {text: 'Stacje Kolejowe', url: '/dispatcher/stations'},
          {text: 'Hotele', url: '/dispatcher/hotels'},
          {text: 'Ustawienia', url: '/dispatcher/settings'}
        ];
      } 
      else if (authStore.user.role === 'ROLE_ADMIN') 
      {
        this.navigationLinks = [
          {text: 'Dashboard', url: '/admin/dashboard'},
          {text: 'Zlecenia', url: '/admin/orders'},
          {text: 'Rozliczenia', url: '/admin/payoff'},
          {text: 'Kierowcy', url: '/admin/drivers'},
          {text: 'Pasażerowie', url: '/admin/passengers'},
          {text: 'Archiwum Zleceń', url: '/admin/orderArchive'},
          {text: 'Firmy', url: '/admin/companies'},
          {text: 'Dyspozytorzy', url: '/admin/dispatchers'},
          {text: 'Stacje Kolejowe', url: '/admin/stations'},
          {text: 'Hotele', url: '/admin/hotels'},
          {text: 'Ustawienia', url: '/admin/settings'}
        ];
      } 
      else if (authStore.user.role === 'ROLE_DRIVER') {
        this.navigationLinks = [
          {text: 'Dashboard', url: '/driver/dashboard'},
          {text: 'Historia', url: '/driver/payoff'},
          {text: 'Wiadomości', url: '/driver/chat'},
          {text: 'Ustawienia', url: '/driver/settings'},
          {text: 'Zgłoś awarię', url: '#', action: this.fetchWarnings }
        ];
      }
    },
    isActiveLink(link) {
      return this.$route.path === link;
    },
    updateDateTime() {
      const now = new Date();
      const day = now.getDate().toString().padStart(2, '0');
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const year = now.getFullYear();
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');
      this.currentDateTime = `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    },
    showSettingsMessage() {
      this.isSettingsModalVisible = true;
    },
    handleResize() {
      this.isDesktop = window.innerWidth >= 1024; // Aktualizacja wartości isDesktop
    }
  },
  mounted() {
    this.setupNavigationLinks();
    this.updateDateTime();
    setInterval(this.updateDateTime, 1000);

    // Sprawdź lokalne ustawienie motywu przy pierwszym uruchomieniu
    const savedTheme = localStorage.getItem('theme') || 'light';
    this.isDarkMode = savedTheme === 'dark';
    document.documentElement.classList.toggle('dark', this.isDarkMode);

    // Dodaj nasłuchiwanie zmiany rozmiaru okna
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll); // Nasłuchuj przewijania
  },
  beforeUnmount() { // Zamiast beforeDestroy
    // Usuń nasłuchiwanie przy odmontowywaniu komponentu
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll); // Usuń nasłuch przewijania
    document.body.classList.remove('overflow-hidden');
  }
};
</script>

<style scoped>
/* Ciemna nakładka */
.transition-opacity {
  transition: opacity 0.3s ease-in-out;
}

button[v-show="false"] {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.1s ease, visibility 0.1s ease;
}

/* Blokada przewijania całej strony */
body.overflow-hidden {
  overflow: hidden;
}

/* Styl dla zawartości sidebaru */
.sidebar-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow-y: auto; /* Przewijanie, jeśli zawartość się nie mieści */
}

.sidebar-content ul li a,
.sidebar-content button,
.sidebar-content a {
  font-size: 1rem; /* Domyślny rozmiar tekstu */
  padding: 0.75rem 1rem; /* Domyślny padding */
  transition: font-size 0.3s ease, padding 0.3s ease; /* Płynne przejścia */
}

/* Styl dla stopki sidebaru */
.sidebar-footer {
  position: sticky;
  bottom: 0;
  background-color: inherit; /* Zachowanie tła sidebaru */
  padding: 1rem; /* Podstawowy padding */
  z-index: 10; /* Priorytet na warstwy */
  display: flex;
  flex-direction: column;
  gap: 0.75rem; /* Dodanie odstępów między elementami */
}

/* Styl dla sticky headera w sidebarze */
.sidebar-header {
  z-index: 10; /* Aby była nad elementami nawigacji */
}

/* Zmniejszenie przycisków i tekstów dla większych skal */
@media (min-width: 768px) and (max-width: 1024px) {
  .sidebar-content ul li a,
  .sidebar-content button,
  .sidebar-content a {
    font-size: 0.9rem; /* Zmniejszony tekst */
    padding: 0.6rem 0.8rem; /* Zmniejszony padding */
  }
}

@media (min-width: 1025px) and (max-height: 900px) {
  .sidebar-content ul li a,
  .sidebar-content button,
  .sidebar-content a {
    font-size: 0.8rem; /* Jeszcze mniejszy tekst */
    padding: 0.5rem 0.7rem; /* Jeszcze mniejszy padding */
  }
}

@media (max-height: 600px) {
  .sidebar-content ul li a,
  .sidebar-content button,
  .sidebar-content a {
    font-size: 0.75rem; /* Minimalny tekst */
    padding: 0.4rem 0.6rem; /* Minimalny padding */
  }
}

/* Styl dla ikon w sidebarze */
.sidebar-content ul li span svg,
.sidebar-content button span svg,
.sidebar-content a span svg {
  width: 1.5rem; /* Domyślny rozmiar ikon */
  height: 1.5rem;
  transition: width 0.3s ease, height 0.3s ease;
}

/* Zmniejszenie ikon dla większych skal */
@media (min-width: 768px) and (max-width: 1024px) {
  .sidebar-content ul li span svg,
  .sidebar-content button span svg,
  .sidebar-content a span svg {
    width: 1.25rem;
    height: 1.25rem;
  }
}

@media (min-width: 1025px) and (max-height: 900px) {
  .sidebar-content ul li span svg,
  .sidebar-content button span svg,
  .sidebar-content a span svg {
    width: 1rem;
    height: 1rem;
  }
}

@media (max-height: 600px) {
  .sidebar-content ul li span svg,
  .sidebar-content button span svg,
  .sidebar-content a span svg {
    width: 0.8rem;
    height: 0.8rem;
  }
}



/* Pasek przewijania w trybie ciemnym */
.dark .sidebar-content::-webkit-scrollbar {
  width: 8px; /* Szerokość paska przewijania */
}

.dark .sidebar-content::-webkit-scrollbar-thumb {
  background-color: #2c7a7a; /* Teal-700 */
  border-radius: 8px; /* Zaokrąglenie suwaka */
  border: 2px solid #1a5d5d; /* Ciemniejszy odcień teal dla krawędzi suwaka */
}

.dark .sidebar-content::-webkit-scrollbar-track {
  background-color: #333333; /* Ciemne tło dla śledzenia paska */
  border-radius: 8px; /* Zaokrąglenie tła paska */
}

/* Pasek przewijania w trybie jasnym */
.sidebar-content::-webkit-scrollbar {
  width: 8px; /* Szerokość paska przewijania */
}

.sidebar-content::-webkit-scrollbar-thumb {
  background-color: #d1d5db; /* Jasnoszary kolor suwaka (szary) */
  border-radius: 8px; /* Zaokrąglenie suwaka */
  border: 2px solid #9ca3af; /* Ciemniejszy szary dla krawędzi suwaka */
}

.sidebar-content::-webkit-scrollbar-track {
  background-color: #f3f4f6; /* Jasnoszare tło dla śledzenia paska */
  border-radius: 8px; /* Zaokrąglenie tła paska */
}

/* Styl dla sekcji nawigacyjnej z paskiem przewijania po lewej stronie */
.sidebar-navigation {
  direction: rtl; /* Przenosi scrollbar na lewą stronę */
  text-align: left; /* Przywraca wyrównanie tekstu */
  max-height: calc(100vh - 10rem); /* Dopasowanie wysokości */
  overflow-y: auto; /* Włączenie przewijania */
  padding-right: 1rem; /* Odsunięcie treści od scrollbara */
}

/* Resetowanie kierunku dla zawartości wewnętrznej sekcji nawigacyjnej */
.sidebar-navigation * {
  direction: ltr; /* Przywrócenie standardowego kierunku tekstu */
}

/* Pasek przewijania w trybie jasnym */
.sidebar-navigation::-webkit-scrollbar {
  width: 8px; /* Szerokość paska przewijania */
}

.sidebar-navigation::-webkit-scrollbar-thumb {
  background-color: #d1d5db; /* Jasnoszary kolor suwaka */
  border-radius: 8px; /* Zaokrąglenie suwaka */
  border: 2px solid #f3f4f6; /* Lekkie obramowanie */
}

.sidebar-navigation::-webkit-scrollbar-track {
  background-color: #f3f4f6; /* Jasnoszare tło */
  border-radius: 8px; /* Zaokrąglenie tła */
}

/* Pasek przewijania w trybie ciemnym */
.dark .sidebar-navigation::-webkit-scrollbar {
  width: 8px; /* Szerokość paska przewijania */
}

.dark .sidebar-navigation::-webkit-scrollbar-thumb {
  background-color: #2c7a7a; /* Teal-700 */
  border-radius: 8px; /* Zaokrąglenie suwaka */
  border: 2px solid #1a5d5d; /* Obramowanie ciemniejszego teal */
}

.dark .sidebar-navigation::-webkit-scrollbar-track {
  background-color: #333333; /* Ciemne tło dla śledzenia */
  border-radius: 8px; /* Zaokrąglenie tła */
}
</style>